var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataNotAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 72,
    viewBox: "0 0 68 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#F60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47 8v32.639C47 46.36 42.359 51 36.633 51H13v-4.328L40.361 18.07v3.73c0 .897.733 1.625 1.64 1.625.906 0 1.638-.728 1.638-1.624v-8.12c0-.021-.011-.04-.013-.06-.003-.117-.038-.228-.069-.34-.024-.094-.036-.19-.077-.276-.037-.084-.101-.153-.157-.23-.069-.1-.131-.199-.22-.28-.014-.015-.021-.034-.037-.047-.06-.05-.131-.068-.195-.109-.099-.063-.195-.128-.307-.17-.11-.04-.218-.05-.33-.065-.08-.012-.15-.047-.234-.047h-8.194c-.906 0-1.639.727-1.639 1.624 0 .896.733 1.624 1.639 1.624h4.631L13 41.86 13.001 8H47z",
    transform: "translate(-686 -169) translate(686 169) translate(8 12)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#F6A11D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.364 17.053c0 .755-.611 1.368-1.364 1.368-.753 0-1.364-.613-1.364-1.368v-5.474c0-.755.611-1.368 1.364-1.368.753 0 1.364.613 1.364 1.368v5.474zM15 22.526c-.753 0-1.364-.613-1.364-1.368 0-.755.611-1.369 1.364-1.369.753 0 1.364.614 1.364 1.369s-.611 1.368-1.364 1.368zm14.402-.953L18.94 4.168C18.123 2.81 16.65 2 15 2s-3.123.81-3.94 2.168L.598 21.573c-.775 1.29-.798 2.842-.062 4.15C1.326 27.128 2.86 28 4.538 28h20.924c1.678 0 3.212-.872 4.002-2.277.736-1.308.713-2.86-.062-4.15z",
    transform: "translate(-686 -169) translate(686 169)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataNotAvailable);
export default __webpack_public_path__ + "static/media/data-not-available.ac5132c7ffad18c993fc6dde49ca24bc.svg";
export { ForwardRef as ReactComponent };